var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"favourites-wrapper"},_vm._l((_vm.res),function(jokes){return _c('div',{key:jokes.id},[_c('Card',{attrs:{"id":jokes.id,"title":("joke no.: " + (jokes.id)),"text":jokes.joke}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }